module.exports = global["jQuery"] = require("-!/opt/lampp/htdocs/rheinkardio/wp-content/themes/rheinkardio/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0